import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
var EnvironmentContext = /*#__PURE__*/ createContext(undefined);
export var EnvironmentProvider = function EnvironmentProvider(param) {
    var children = param.children, environment = param.environment;
    return /*#__PURE__*/ _jsx(EnvironmentContext.Provider, {
        value: {
            environment: environment
        },
        children: children
    });
};
export var useEnvironment = function useEnvironment() {
    var context = useContext(EnvironmentContext);
    if (context === undefined) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};
